/**
 * Get constituent string properties of given URL, relative or absolute, as a
 * POJO. These strings correspond to Location object (i.e. window.location)
 * @param {string} relativeOrAbsoluteUrl 
 * @return {Location}
 */
export const canonicalizeUrl = (relativeOrAbsoluteUrl) => {
    const a = document.createElement('a');
    a.href = relativeOrAbsoluteUrl;

    return {
        hash: a.hash,
        host: a.host,
        hostname: a.hostname,
        href: a.href,
        origin: a.origin,
        pathname: a.pathname,
        port: a.port,
        protocol: a.protocol,
        search: a.search,
    };
};

/**
 * Get subdomain of hostname, given expected domain. Return null when hostname
 * not within expected domain. Checking specific domain avoids reliance on
 * large ICANN TLD lists needed for actual general domain recognition.
 * @param {string} hostname 
 * @param {string} expectedDomain 
 */
export const subdomainOf = (hostname, expectedDomain) => {
    // Without the '.' it's not really the domain
    const dottedDomain = `.${expectedDomain}`;
    if (!hostname.endsWith(dottedDomain)) {
        return null;
    }

    const domainIndex = hostname.lastIndexOf(dottedDomain);
    const subdomain = hostname.substring(0, domainIndex);
    return subdomain;
};


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/util/url.js